import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import Image from '@/shared/Image';
import React from 'react';
import Heading from '@/shared/Heading';

type MainHeaderProps = {
  mainHeader: {
    name: string;
    subCategoryId?: string;
    description: string;
    image: any;
  };
};

function MainHeader({ mainHeader }: MainHeaderProps) {
  const { image = {}, name, description } = mainHeader || {};

  const { url, height, width } = image;

  return (
    <Div className="pt-s3 lg:pt-s5 pb-s3">
      <Div className="w-full flex justify-center">
        <Div className="w-26 h-26  ">
          <Image
            src={url}
            priority
            alt={name}
            className="h-full w-full main-img"
            width={width}
            height={height}
          />
        </Div>
      </Div>
      <Heading level={1} className="text-primary-black mt-s6 text-h-1 text-center">
        {name}
      </Heading>
      <Div className="w-full flex justify-center">
        <Div
          className="mb-s5 mt-s3 text-center w-66"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Div>
    </Div>
  );
}

export default React.memo(MainHeader);
